import ConfigHelper from 'framework/helpers/config'
import { of, throwError } from 'rxjs'
import { catchError, mergeMap, switchMap } from 'rxjs/operators'
import Fetch from '../fetch'
import DataHelper from 'framework/helpers/data'
import Constants from 'api-constants'
import { useApiLoginV2 } from 'services/huawei/Helpers'

export default class SoloAuthApi extends Fetch {
    constructor(config, otherApis = {}) {
        super(config, otherApis)

        this.soloAuthUrl = ConfigHelper.getInstance().getConfig('urls').soloAuthUrl
        this.commonApi = otherApis.commonApi
    }

    generateAccessToken() {
        this.logger.info(`generating access tocken`)
        return this.fetch({
            url: `${this.soloAuthUrl}/mcrosrvc/oauth/accesstoken`,
            method: 'POST',
            headers: {
                'Content-Type': Constants.httpHeader.ContentType.APPLICATION_WWW_FORM_URLENCODED,
                Authorization: `Basic ${this.config.ooredoo.soloToken}`,
            },
            body: {
                grant_type: 'client_credentials',
            },
            log: 'GENERATE ACCESS TOCKEN',
        }).pipe(
            mergeMap((response) => {
                return DataHelper.getInstance()
                    .storeData([
                        [DataHelper.STORE_KEY.SOLO_AUTH_TOKEN, response.response.access_token],
                    ])
                    .pipe(switchMap(() => of(response.response.access_token)))
            }),
            catchError((error) => {
                return throwError(error)
            })
        )
    }

    generateOTPCode(serviceNumber) {
        const locale = this.commonApi.getLocale()
        const myLocale = locale.length >= 2 ? locale.slice(0, 2) : 'en'

        return this.fetch({
            url: `${this.soloAuthUrl}/mcrosrvc/v2/extendooredootvms/generate-otp-huawei-details`,
            method: 'POST',
            headers: {
                'Content-Type': Constants.httpHeader.ContentType.APPLICATION_JSON,
                lang: myLocale === 'ar' ? 'ARABIC' : 'ENGLISH',
                Authorization: `Bearer ${DataHelper.getInstance().getData(
                    DataHelper.STORE_KEY.SOLO_AUTH_TOKEN
                )}`,
            },
            body: {
                serviceNumber,
            },
            allowReloginWhenSessionEnded: false,
            cookiesLessQuery: true,
            log: 'AUTH OTP',
        }).pipe(
            mergeMap((response) => {
                return of(response)
            }),
            catchError((error) => {
                this.logger.warn('Unable to authenticate with otp', error)
                return throwError(error)
            })
        )
    }

    validateOTPSOLO(serviceNumber, otp) {
        const locale = this.commonApi.getLocale()
        const myLocale = locale.length >= 2 ? locale.slice(0, 2) : 'en'
        const urlToUse = useApiLoginV2()
            ? `${this.config.urls.soloAuthUrl}/mcrosrvc/v2/extendooredootvms/validate-otp-by-huawei-service-num`
            : `${this.config.urls.soloVerifyOtpUrl}/mcrosrvc/v2/solologin/validateotpbyhuaweiforaccesstoken`

        const tokenToUse = useApiLoginV2()
            ? `Bearer ${DataHelper.getInstance().getData(DataHelper.STORE_KEY.SOLO_AUTH_TOKEN)}`
            : `Basic ${this.config.ooredoo.soloToken}`

        return this.fetch({
            url: urlToUse,
            method: 'POST',
            headers: {
                'Content-Type': Constants.httpHeader.ContentType.APPLICATION_JSON,
                lang: myLocale === 'ar' ? 'ARABIC' : 'ENGLISH',
                Authorization: tokenToUse,
            },
            body: {
                otp,
                serviceNumber,
            },
            allowReloginWhenSessionEnded: false,
            cookiesLessQuery: true,
            log: 'AUTH OTP',
        }).pipe(
            switchMap((res) => {
                const useLoginV2 = useApiLoginV2()
                if (useLoginV2) {
                    return of(res)
                } else {
                    const accessToken = res?.response?.accessToken
                    return DataHelper.getInstance()
                        .storeData([[DataHelper.STORE_KEY.SOLO_USER_TOKEN, accessToken]])
                        .pipe(
                            switchMap(() => {
                                return of(res)
                            }),
                            catchError((error) => {
                                return throwError(error)
                            })
                        )
                }
            }),
            catchError((error) => {
                this.logger.warn('Unable to authenticate with otp', error)
                return throwError(error)
            })
        )
    }
}
